import { render, staticRenderFns } from "./OpenPrivateSpace.vue?vue&type=template&id=3496ceba"
import script from "./OpenPrivateSpace.vue?vue&type=script&lang=js"
export * from "./OpenPrivateSpace.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports